export default () => ({
    init() {
        this.$watch('scrollNum', value => {
            this.updateStyle()
        })
        this.updateStyle()
    },
    updateStyle() {
        this.$el.style.transform = this.$el.dataset.style.replace('$$$', this.scrollNum)
    }
})